import { render, staticRenderFns } from "./kx1-imgs-swiper.vue?vue&type=template&id=702ecbd8&scoped=true"
import script from "./kx1-imgs-swiper.vue?vue&type=script&lang=js"
export * from "./kx1-imgs-swiper.vue?vue&type=script&lang=js"
import style0 from "./kx1-imgs-swiper.vue?vue&type=style&index=0&id=702ecbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702ecbd8",
  null
  
)

export default component.exports